module.exports = __webpack_public_path__ + "img/logo-stacked-whitetext.6fdb71db.svg";